export interface CounterOptions {
    container: HTMLElement;
    duration?: number;
}

export class Counter {


    public onComplete = e5.Signal.create();

    private _options: CounterOptions;
    private _element: HTMLElement;
    private _duration: number;

    constructor(options: CounterOptions) {
        options = e5.object.merge({
            duration: 2
        }, options);
        this._options = options;

        this._element = document.createElement("div");
        this._element.className = "counter";
        this._element.innerHTML = `<div class="counter__value"></div>`;

        this._duration = options.duration / 3;

        if (options.container) {
            options.container.appendChild(this._element);
        }
    }

    public stop():void{
        gsap.killTweensOf(this._element);
        this._element.style.opacity = "0";
        this._element.style.transform = "scale(0.1)";
    }

    public start(): void {
        this.stop();

        this.setValue("3", () => {
            this.setValue("2", () => {
                this.setValue("1", () => {
                    gsap.to(this._element,
                        {
                            scale: 0.1,
                            opacity: 0,
                            duration: 0.25
                        });
                    this.onComplete.dispatch();
                });
            });
        });
    }

    private setValue(value: string, onComplete: () => void): void {
        this._element.querySelector(".counter__value").textContent = value;
        gsap.fromTo(this._element,
            {

                scale: 0.25,
                opacity: 0
            },
            {
                scale: 1,
                opacity: 1,
                duration: this._duration,
                onComplete: onComplete
            });
    }
}